import {TBadgeColor} from 'src/components';
import {TSubject} from 'src/constants';

import {EResellerIds} from '../User';

export enum EStatus {
  DRAFT = 'DRAFT',
  LOGIN_REQUIRED = 'LOGIN_REQUIRED',
  CREATE_SUBJECT = 'CREATE_SUBJECT',
  CREATE_SUBJECT_ERROR = 'CREATE_SUBJECT_ERROR',
  IN_PROGRESS = 'IN_PROGRESS',
  CANCELLED = 'CANCELLED',
  DONE = 'DONE',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
}

export enum EFormSteps {
  SETTINGS = 'SETTINGS',
  QR = 'QR',
}

export enum EQrStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  EXPIRED = 'EXPIRED',
}

export type TMaxChannel = {
  id: number;
  status: EStatus;
  name: string;
  availableTariffId?: number;
  qrLink?: string;
  subjectRef?: TSubject;
  // for tech partner channel
  code?: string;
  clientProfileId?: number;
};

export type TFormData = Partial<TMaxChannel>;

export const statusColorHash: Record<keyof typeof EStatus, TBadgeColor> = {
  DRAFT: 'BLUE',
  LOGIN_REQUIRED: 'PURPLE',
  TOKEN_EXPIRED: 'PURPLE',
  IN_PROGRESS: 'YELLOW',
  CREATE_SUBJECT: 'YELLOW',
  CREATE_SUBJECT_ERROR: 'GREY',
  CANCELLED: 'GREY',
  DONE: 'GREEN',
};

export enum ETechPartnerStatus {
  NEW = 'NEW',
  ACCEPTED = 'ACCEPTED',
  DELETED = 'DELETED',
}

export type TTechPartnerChannel = {
  id: number;
  name: string;
  availableTariffId?: number;
  code: string;
  status: ETechPartnerStatus;
};

export const techPartnerStatusColorHash: Record<keyof typeof ETechPartnerStatus, TBadgeColor> = {
  NEW: 'BLUE',
  ACCEPTED: 'GREEN',
  DELETED: 'GREY',
};

export enum EPublicStatus {
  NEW = 'NEW',
  ACCEPTED = 'ACCEPTED',
  DELETED = 'DELETED',
}

export type TPublicChannel = {
  id: number;
  partnerName: string;
  status: EPublicStatus;
  resellerId: EResellerIds;
  code: string;
  availableTariffId: number;
  createdAt?: string;
  updatedAt?: string;
};
